import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const user = localStorage.getItem('user');
  
  if (user) {
    // Redirect to dashboard if already authenticated
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;
